import { ArkikSpinnerComponentModule } from '@shared/components/arkik-spinner/arkik-spinner-component.module';
import { OfflineAlertComponentModule } from '@shared/components/arkik-offline-alert/offline-alert-component.module';
import { ModalConfirmationComponentModule } from '@shared/components/modal-confirmation/modal-confirmation-component.module';
import { PwaInstallInstructionsComponentModule } from '@shared/components/pwa-install-instructions/pwa-install-instructions-component.module';

/**
 * Modules for components that are created programmatically via ComponentPortal or ArkikDialogService.
 * These must be imported at app root level so Ivy compiles and includes them.
 */
export const PROGRAMMATIC_COMPONENT_MODULES = [
  ArkikSpinnerComponentModule, // ArkikLoaderService
  OfflineAlertComponentModule, // PlantOfflineAlertService
  ModalConfirmationComponentModule, // ArkikDialogService.open(ModalConfirmationComponent)
  PwaInstallInstructionsComponentModule,
];
